const getExchangeName = key =>
  ({
    OSE: 'Oslo Børs',
    OAX: 'Euronext Expand',
    MERK: 'Euronext Growth',
    SSE: 'Nasdaq Stockholm',
    FNSE: 'First North Stockholm',
    XSAT: 'Aktietorget',
    NGM: 'NGM',
    'XNGM-NEST': 'NGM Equity',
    'XNGM-NDXS': 'NDX',
    NMTF: 'NGM Nordic MTF',
  }[key] || key);

export default getExchangeName;
